// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_search_tracks_home_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Discover our collection of amazing tracks and find all the music you need in one place. Every song and track variation is well thought out, composed, produced and curated to add value to your productions. Genres, moods and tags are designed to make you find the perfect song for all your projects in a matter of seconds.`
};

const de_search_tracks_home_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Entdecke unsere beeindruckende Musik und finde den perfekten Titel für dein Projekt - alles direkt an einem Ort. Alle Song- und Track-Variationen sind gründlich durchdacht, komponiert, produziert und kuratiert, um deinen Produktionen einen großartigen Mehrwert zu verleihen. Genres, Stimmungen und Tags sind so gewählt, dass du in Sekundenschnelle die perfekten Songs für alle deine Projekte findest.`
};

const es_search_tracks_home_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Descubre nuestra colección de pistas increíbles y encuentre toda la música que necesita en un solo lugar. Cada canción y variación de pista está bien pensada, compuesta, producida y curada para agregar valor a tus producciones. Los géneros, estados de ánimo y etiquetas están diseñados para que encuentres la canción perfecta para todos tus proyectos en cuestión de segundos.`
};

const pt_br_search_tracks_home_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Descubra nossa coleção de faixas incríveis e encontre todas as músicas de que você precisa em um só lugar. Cada música e variação de faixa são bem pensadas, compostas, produzidas e selecionadas para agregar valor às suas produções. Gêneros, humores e tags são projetados para fazer você encontrar a música perfeita para todos os seus projetos em questão de segundos.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "pt-br" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const search_tracks_home_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search_tracks_home_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("search_tracks_home_subtitle", locale)
	if (locale === "en") return en_search_tracks_home_subtitle(inputs)
	if (locale === "de") return de_search_tracks_home_subtitle(inputs)
	if (locale === "es") return es_search_tracks_home_subtitle(inputs)
	return pt_br_search_tracks_home_subtitle(inputs)
};
export { search_tracks_home_subtitle as "search.tracks-home-subtitle" }